import { IEnvironment } from '@mnz-core/models/environment';
import { appVersion } from '@mnz/app.version';

export const environment: IEnvironment = {
  ...appVersion,
  production: true,
  name: 'Mijn NS Zakelijk',
  redirectAfterLogin: true,
  api: {
    mock: false,
    delayMs: 0
  },
  sentry: {
    key: 'a1d93883c59b45b49cac01bd11a618f4',
    projectId: 279909
  }
};
